import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
const UpdateDrawerInfo = (props) => {
    const {title, information} = props;
    return (
        <div className="card bg-light" style={{ position: 'sticky',overflow: 'auto',height: '80vh', maxHeight: 'fit-content', top:'40px'}}>
            <div className="card-body pb-0">
                <div className="d-flex align-items-center mb-2">
                    <div className="d-flex align-items-center flex-grow-1">
                        <div className="d-flex flex-column">
                            <div className="text-gray-900 fs-5 fw-bold">
                                {title}
                            </div>
                        </div>
                    </div>
                    <div className="my-0">
                        <FontAwesomeIcon 
                            icon={faXmark} 
                            className='fs-2 cursor-pointer' 
                            onClick={props.infoCloseOnClick}
                        />
                    </div>
                </div>
                <div className="mb-5">
                    <p
                        className="text-gray-600 fs-5"
                        dangerouslySetInnerHTML={{ __html: information }}
                    ></p>
                    {/* <p className="text-gray-600 fs-5">
                        {information}
                    </p> */}
                </div>
            </div>
        </div>
    )
}

export default UpdateDrawerInfo